<template>
  <el-dialog
    title="修改公司信息"
    :visible.sync="dialogFormEditCompanyInfo"
    @close="close"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" label-width="100" ref="form">
      <el-form-item label="主营业务描述：" prop="businessDesc">
        <el-input v-model="form.businessDesc" type="textarea"></el-input>
      </el-form-item>

      <el-form-item label="办公地址：" prop="workAddress">
        <el-input v-model="form.workAddress"></el-input>
      </el-form-item>

      <el-form-item label="联系人姓名：" prop="contracter">
        <el-input v-model="form.contracter"></el-input>
      </el-form-item>

      <el-form-item label="联系电话：" prop="tel">
        <el-input v-model="form.tel"></el-input>
      </el-form-item>

      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifySecondInfo } from '@/api/distributor-api'
import {
  DISTRIBUTOR_COMPANY_INFO_RULE,
  OWNER_COMPANY_INFO_RULE,
} from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      distributorId: this.$route.params.id,
      form: {
        businessDesc: '',
        workAddress: '',
        contracter: '',
        tel: '',
        email: '',
      },
      // rules: DISTRIBUTOR_COMPANY_INFO_RULE.call(this)
    }
  },

  watch: {
    infoData(val) {
      this.form = Object.assign({}, val)
    },
  },
  computed: {
    rules() {
      let rule = OWNER_COMPANY_INFO_RULE.call(this)
      return {
        ...DISTRIBUTOR_COMPANY_INFO_RULE,
        ...rule,
      }
    },
  },
  mounted() {},
  created() {},
  filters: {},
  methods: {
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.form = Object.assign({}, this.infoData)
    },
    close() {
      this.$refs.form.resetFields()
      this.dialogFormEditCompanyInfo = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateFirstClientInfo()
        } else {
          return false
        }
      })
    },
    async updateFirstClientInfo() {
      let { businessDesc, workAddress, contracter, tel, email } = this.form
      let { distributorId } = this
      let submitForm = Object.assign({}, this.form)
      submitForm.distributorId = distributorId
      if (
        businessDesc !== this.infoData.businessDesc ||
        workAddress !== this.infoData.workAddress ||
        contracter !== this.infoData.contracter ||
        tel !== this.infoData.tel ||
        email !== this.infoData.email
      ) {
        await modifySecondInfo(submitForm)
        this.outMsg('success', '提交成功')
        this.close()
        this.$emit('submitSuccess')
      } else {
        this.close()
      }
    },
  },
}
</script>
